module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h3', [_vm._v("Single Play Music Box")]), _vm._v(" "), _c('p', [_vm._v("If you don't know what these are I suggest not touching them other than turning them on or off. V v much a work in progress. See the Under Construction Club widget for more.")]), _vm._v(" "), _c('p', [_vm._v("Interval input sets the interval at which compounding effects are applied (i.e. in 'volumeDown' volume decreases by one every eight seconds)")]), _vm._v(" "), _vm._l((_vm.mutations), function(mutation, index) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(mutation.type))]), _vm._v(" "), _c('label', [_vm._v("Active")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.active),
        expression: "mutation.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(mutation.active) ? _vm._i(mutation.active, null) > -1 : (mutation.active)
      },
      on: {
        "change": function($event) {
          var $$a = mutation.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (mutation.active = $$a.concat([$$v]))
            } else {
              $$i > -1 && (mutation.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(mutation, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Start")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.start),
        expression: "mutation.start"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (mutation.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(mutation, "start", $event.target.value)
        }
      }
    }), _vm._v(" "), (mutation.interval) ? _c('span', [_c('label', [_vm._v("Additional Effect Interval")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.interval),
        expression: "mutation.interval"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (mutation.interval)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(mutation, "interval", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('pre', [_vm._v(_vm._s(mutation))])])
  }), _vm._v(" "), _c('h3', [_vm._v("Generative Music Box")]), _vm._v(" "), _c('p', [_vm._v("Eventually this thing will let you set multiple short loops with different synth that will play and evolve (note changes, duration changes, phasing, etc) over time. You'll be able to set the rules here")]), _vm._v(" "), _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672959f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/mutation_config.vue
// module id = 284
// module chunks = 1